import { logout } from '../auth.service';
import Login from '../../pages/Login';

const CanolaSeguros = () =>
{    
    localStorage.setItem("tenantId", "canolaseguros");
    localStorage.setItem("logoVertical", "logocanolaseguros");
    localStorage.setItem("logoHorizontal", "logocanolasegurosH");
    logout();
    
    return Login();
};

export default CanolaSeguros;